import { api, type Api } from "@api/bot-base-api-request";
import { useMutation } from "@tanstack/react-query";

const BOT_WALLET_SET_ACTIVE_QUERY_KEY = "bot-wallet-set-active";

type BotWalletSetActiveParams = {
  appPubKey: string;
  userId: string;
  chainId: number;
  walletAddress: string;
};

type BotWalletSetActiveResponse = {
  currentWallet: string;
};

const postBotWalletSetActive = async (
  api: Api,
  params: BotWalletSetActiveParams,
): Promise<BotWalletSetActiveResponse> =>
  api.post("wallet/setActive", { json: params }).json();

const useBotWalletSetActiveMutation = () =>
  useMutation({
    mutationFn: async (params: BotWalletSetActiveParams) =>
      postBotWalletSetActive(api, params),
    mutationKey: [BOT_WALLET_SET_ACTIVE_QUERY_KEY],
  });

export {
  useBotWalletSetActiveMutation,
  postBotWalletSetActive,
  BOT_WALLET_SET_ACTIVE_QUERY_KEY,
};
